/**
 * TanStack Router: /workforce/roles/$roleId/edit
 *
 * Edit existing role
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/roles/[id]/edit.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import EditRolePage from '@/app/workforce/roles/[id]/edit'

/**
 * Route: /workforce/roles/$roleId/edit
 * Layout: _auth (authenticated)
 * Component: EditRolePage
 */
export const Route = createFileRoute('/_auth/workforce/roles/$roleId/edit')({
  component: EditRolePage,
})
